export default class Util {
    static isNullOrUndefined(value) {
        return value === null || typeof value === 'undefined';
    }

    static mapC1GenderToSalutation(gender) {
        switch (gender) {
            case 'male': return 'Herr';
            case 'female': return 'Frau';
            default: return '';
        }
    }

    static masterdataToFullName(masterdata) {
        const gender = masterdata.gender || '';
        const salutation = Util.mapC1GenderToSalutation(gender);
        const firstname = masterdata.first_name || '';
        const lastname = masterdata.last_name || '';
        return `${salutation} ${firstname} ${lastname}`.trim().replace(/ {2,}/, '');
    }

    static infoToAccountStateInfoBox(info) {
        const accountState = {
            title: 'Nutzerstatus',
            text: '',
            icon: '',
            color: '',
            status: info.account_state,
            ssoId: info.user_id,
        };

        switch (info.account_state) {
            case 'activated':
                accountState.text = ['Aktiviert'];
                accountState.icon = 'mdi-thumb-up';
                accountState.color = 'green';
                break;
            case 'registered':
                accountState.text = ['Registriert'];
                accountState.icon = 'mdi-thumb-down';
                accountState.color = 'yellow';
                break;
            case 'locked':
                accountState.text = ['Gesperrt'];
                accountState.icon = 'mdi-account-lock';
                accountState.color = 'red';
                break;
            default:
                accountState.text = ['Unbekannt'];
                accountState.icon = 'mdi-help-circle';
                accountState.color = 'secondary';
        }
        return accountState;
    }

    static formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = `00${date.getMonth() + 1}`.substr(-2);
        const day = `00${date.getDate()}`.substr(-2);
        const hours = `00${date.getHours()}`.substr(-2);
        const minutes = `00${date.getMinutes()}`.substr(-2);
        const seconds = `00${date.getSeconds()}`.substr(-2);
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    static timestampToGermanDate(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = Util.getGermanMonth(date.getMonth() + 1);
        const day = date.getDate();
        return `${day}. ${month} ${year}`;
    }

    static isValidGermanDate(dateAsString) {
        const regex = /[0123][0-9]\.[01][0-9]\.(18|19|20)[0-9]{2}/;
        if (regex.test(dateAsString)) {
            const year = dateAsString.substr(6);
            let month = dateAsString.substr(3, 2);
            month = Number.parseInt(month, 10) - 1;
            let day = dateAsString.substr(0, 2);
            const date = new Date(year, month, day);

            month = `0${(date.getMonth() + 1)}`.substr(-2);
            day = `0${date.getDate()}`.substr(-2);

            return `${day}.${month}.${date.getFullYear()}` === dateAsString;
        }
        return false;
    }

    static getGermanMonth(month) {
        switch (month) {
            case 1: return 'Januar';
            case 2: return 'Februar';
            case 3: return 'März';
            case 4: return 'April';
            case 5: return 'Mai';
            case 6: return 'Juni';
            case 7: return 'Juli';
            case 8: return 'August';
            case 9: return 'September';
            case 10: return 'Oktober';
            case 11: return 'November';
            case 12: return 'Dezember';
            default: return 'unbekannt';
        }
    }

    static timestampToInfoBox(timestamp, title, target = {}, targetTitle = '') {
        const date = Util.toDatetime(timestamp) || '-';
        return {
            icon: 'mdi-calendar',
            title,
            text: [date],
            color: 'blue',
            target,
            targetTitle,
        };
    }

    static download(filename, data) {
        const url = window.URL.createObjectURL(new Blob([
            data,
        ]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    static toDate(timestamp) {
        const date = new Date(timestamp);
        if (!timestamp || date.toString() === 'Invalid Date') {
            return timestamp;
        }
        const year = date.getFullYear();
        const month = `00${date.getMonth() + 1}`.substr(-2);
        const day = `00${date.getDate()}`.substr(-2);
        return `${day}.${month}.${year}`;
    }

    static toDatetime(timestamp) {
        const date = new Date(timestamp);
        if (!timestamp || date.toString() === 'Invalid Date') {
            return timestamp;
        }
        const year = date.getFullYear();
        const month = `00${date.getMonth() + 1}`.substr(-2);
        const day = `00${date.getDate()}`.substr(-2);
        const hours = `00${date.getHours()}`.substr(-2);
        const minutes = `00${date.getMinutes()}`.substr(-2);
        const seconds = `00${date.getSeconds()}`.substr(-2);
        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds} Uhr`;
    }

    static sapDataToFullname(sap) {
        return `${(sap.anrede)} ${(sap.title || '')} ${(sap.vorname || '')} ${(sap.nachname || '')}`
            .trim()
            .replace(/ {2,}/, ' ') || '-';
    }

    static salesforceDataToFullname(salesforce) {
        return `${(salesforce.Salutation || '')} ${(salesforce.FirstName || '')} ${(salesforce.LastName || '')}`
            .trim()
            .replace(/ {2,}/, ' ') || '-';
    }

    static sapDataToBirthdate(sap) {
        return sap.gebdat ? Util.toDate(sap.gebdat) : '-';
    }

    static sapDataToStreet(sap) {
        return `${(sap.strasse || '')} ${(sap.hausnummer || '')}`.trim() || '-';
    }

    static sapDataToCity(sap) {
        return `${(sap.plz || '')} ${(sap.ort || '')}`.trim() || '-';
    }

    static scopeFromGp(gpNumber) {
        const gp = Number.parseInt(gpNumber, 10);
        if (gp < 10000000) {
            return 'NOZ';
        }
        return 'MHN';
    }
}
